import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { EditorModule } from '@tinymce/tinymce-angular'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StudentUserdataCreateComponent } from './student-userdata//student-userdata-create/student-userdata-create.component';
import { StudentUserdataListComponent } from './student-userdata/student-userdata-list/student-userdata-list.component';
import { StudentUsercompareCreateComponent } from './student-usercompare//student-usercompare-create/student-usercompare-create.component';
import { StudentUsercompareListComponent } from './student-usercompare/student-usercompare-list/student-usercompare-list.component';
import { StudentUserwishlistCreateComponent } from './student-userwishlist//student-userwishlist-create/student-userwishlist-create.component';
import { StudentUserwishlistListComponent } from './student-userwishlist/student-userwishlist-list/student-userwishlist-list.component';



import { GalleryModule } from '@ks89/angular-modal-gallery';
import 'hammerjs';
import 'mousetrap';

import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { StudentDetailsRoutingModule } from './student-details-routing.module';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  url: 'https://httpbin.org/post',
};



@NgModule({
  declarations: [
    StudentUserdataListComponent,
    StudentUserdataCreateComponent,
    StudentUsercompareCreateComponent,
    StudentUsercompareListComponent,
    StudentUserwishlistCreateComponent,
    StudentUserwishlistListComponent,

        
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
     EditorModule,
    StudentDetailsRoutingModule,
    Ng2SmartTableModule,
    NgbModule,
    DropzoneModule,
    GalleryModule.forRoot()
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    NgbActiveModal
  ]
})
export class StudentDetailsModule { }
